import * as bhListContext from './bh-list-context'
import * as bhSearch from './bh-search'
import * as clerk from './clerk'
import customTrackings from './custom-trackings'
import * as dummy from './dummy'
import * as gtm from './gtm'
import * as gtmGa4 from './gtm-ga4'
import * as sizebay from './sizebay'

const trackings = {
	'bh-list-context': bhListContext,
	'bh-search': bhSearch,
	'gtm-ga4': gtmGa4,
	clerk,
	dummy,
	gtm,
	sizebay,
	...customTrackings,
}

export const getTrackingHandler = (trackingId) => trackings[trackingId]
